module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_features_01-f5f7f4037ac0a38fdae8cb8cae3e1678.png";